<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10.6389" y="8.28707" width="9.49365" height="9.49365" rx="1.3" transform="rotate(45 10.6389 8.28707)" stroke="currentColor" stroke-width="1.4"/>
<rect x="20.0637" y="14.3" width="15" height="1.4" rx="0.7" fill="currentColor"/>
</svg>
